import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

const PageWrapper = styled.main`
  width: 100%;
  max-width: 1176px;
  margin: var(--p-spacing-48) auto;
  padding: 0 var(--p-spacing-16);
`;

export const Header = styled.h2``;

interface Props {
  children: ReactNode;
}

export function PageLayout({ children }: Props): ReactElement {
  return <PageWrapper>{children}</PageWrapper>;
}
